import React from "react";
import AboutSection from "../components/AboutSection";

export default function AboutPage() {
  return (
    <div>
      <AboutSection />
    </div>
  );
}
